// extracted by mini-css-extract-plugin
export default {"dashboard_col_3":"Dashboard_dashboard_col_3__a8gf6","dashboard_col_9":"Dashboard_dashboard_col_9__LPo+W","navbar_sticky":"Dashboard_navbar_sticky__8SXf+"};